import { useLazyQuery } from 'data-fetching-client';
import { useEffect, useMemo } from 'react';
import { GET_FORM_PERMISSIONS } from 'ui-forms-components/api/dataFetchingClient/queries/getFormPermissions';
import isSingleTruthyValue from 'forms-utils-lib/utils/array/isSingleTruthyValue';
const useFetchFormPermissions = formGuids => {
  const [getFormPermissions, {
    called,
    data,
    loading,
    error
  }] = useLazyQuery(GET_FORM_PERMISSIONS);
  useEffect(() => {
    if (isSingleTruthyValue(formGuids)) {
      const [formGuid] = formGuids;
      getFormPermissions({
        variables: {
          formGuid
        }
      });
    }
  }, [formGuids, getFormPermissions]);
  const permissions = useMemo(() => data ? data.getFormPermissions : {
    userIds: [],
    teamIds: []
  }, [data]);
  return useMemo(() => ({
    permissions,
    loading,
    called,
    error
  }), [called, error, loading, permissions]);
};
export default useFetchFormPermissions;